import { Button } from "@mui/material";
import useAPI from "../../../../api/hooks/useAPI";
import useColors from "../../../../api/hooks/useColors";
import CustomToolTip from "../../../../components/CustomTooltip";
import { Toast } from "../../../../components/Toast";

const SendScheduledNotificationButton = () => {
  const colors = useColors();
  const { sendScheduledNotification } = useAPI();

  const handleOnClick = () => {
    sendScheduledNotification()
      .then(() => {
        Toast.success("Scheduled notification sent");
      })
      .catch(() => {
        Toast.error("Error sending scheduled notification");
      });
  };

  return (
    <>
      <CustomToolTip title="Make sure the scheduled time you want is set!">
        <Button
          variant="outlined"
          sx={{
            backgroundColor: colors.secondary_main,
            "&:hover": {
              backgroundColor: colors.secondary_dark,
            },
          }}
          onClick={handleOnClick}
        >
          Send a scheduled notification
        </Button>
      </CustomToolTip>
    </>
  );
};

export default SendScheduledNotificationButton;
